import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_reset_password",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "form-group mr-b-0em" }
const _hoisted_8 = { class: "form-group mr-b-0em" }
const _hoisted_9 = { class: "form-group mr-b-0em" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 text-right" }
const _hoisted_12 = { class: "col-md-6 text-right" }
const _hoisted_13 = {
  type: "submit",
  class: "w-100 btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_inputText = _resolveComponent("inputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestUser)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('auth.login.reset_password')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_reset_password', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestResetPassword)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_inputText, {
                    modelValue: _ctx.requestResetPassword.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestResetPassword.email) = $event)),
                    label: _ctx.i18n.t('auth.reset.email'),
                    v: _ctx.v$.email,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_inputText, {
                    modelValue: _ctx.requestResetPassword.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestResetPassword.password) = $event)),
                    label: _ctx.i18n.t('auth.reset.password'),
                    v: _ctx.v$.password,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_inputText, {
                    modelValue: _ctx.requestResetPassword.password_confirmation,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestResetPassword.password_confirmation) = $event)),
                    label: _ctx.i18n.t('auth.reset.password_confirmation'),
                    v: _ctx.v$.password_confirmation,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('modal_reset_password', 'add'))),
                      class: "w-100 btn btn-cancel"
                    }, _toDisplayString(_ctx.i18n.t('button.close')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.i18n.t('button.reset_password')), 1)
                  ])
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}